export default "__VITE_ASSET__66d45041__"